import React, { useState } from 'react';
import clsx from 'clsx';
import Button from '../Shared/components/controls/Button';
import './style.scss';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import Card from './Card';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { withTranslation } from 'react-i18next';

const CardLogoDescription = ({ fields = {}, params, i18n }) => {
  const { heading, items, primaryButton, secondaryButton, tertiaryButton, text } = fields;

  const shouldRenderHeading = !!heading?.value;
  const shouldRenderItems = Array.isArray(items) && items.length > 0;
  const shouldRenderPrimaryButton = !!primaryButton?.value?.href;
  const shouldRenderSecondaryButton = !!secondaryButton?.value?.href;
  const shouldRenderTertiaryButton = !!tertiaryButton?.value?.href;
  const shouldRenderText = !!text?.value;

  const theme = params?.theme?.toLowerCase();

  const renderMainCard = () => {
    return (
      <div className="main-card">
        {shouldRenderHeading && (
          <h2>
            <Text field={heading} />
          </h2>
        )}
        {shouldRenderText && <RichText className="main-card-text" field={text} />}
        {shouldRenderPrimaryButton && (
          <Button link={primaryButton} className="main-card-link main-card-primary-link" />
        )}
        {shouldRenderSecondaryButton && (
          <Button link={secondaryButton} className="main-card-link main-card-secondary-link" />
        )}
        {shouldRenderTertiaryButton && (
          <Button link={tertiaryButton} className="main-card-link main-card-tertiary-link" />
        )}
      </div>
    );
  };

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className={clsx('card-logo-description', 'add-margins', params?.Styles)}>
      <div className="cards-wrapper">
        <div className="sub-cards d-none d-md-flex">
          {renderMainCard()}
          {shouldRenderItems &&
            items.map((item, index) => {
              return <Card key={index} data={item?.fields} theme={theme} />;
            })}
        </div>
        <div className="sub-cards d-md-none">
          {renderMainCard()}
          <Swiper
            dir={i18n.language === 'en' ? 'ltr' : 'rtl'}
            spaceBetween={1}
            slidesPerView={'auto'}
            freeMode={true}
            onSlideChange={(e) => {
              setTimeout(() => {
                setSelectedIndex(e.activeIndex);
              }, 1500);
            }}
            className="cards-swiper d-md-none"
          >
            {items.map((item, index) => {
              return (
                <SwiperSlide
                  key={index}
                  className={clsx('card-slide', selectedIndex === index && 'selected-slide')}
                >
                  <Card data={item?.fields} theme={theme} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(CardLogoDescription);
